export default __webpack_public_path__ + "static/knowledgePlaceholder-2b2939b12fb3455937fef8275ea25af4.jpg";